module.exports = __webpack_public_path__ + "static/media/rabbit-l.d629311a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/rabbit-l.png
// module id = 855
// module chunks = 0